export const CONTACT_FORM_SENT = 'CONTACT_FORM_SENT';
export const CONTACT_FORM_SENDING = 'CONTACT_FORM_SENDING';
export const CONTACT_FORM_ERROR = 'CONTACT_FORM_ERROR';



// WEBPACK FOOTER //
// ./src/features/Contact/types.js